import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationResolvedStateToggledProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_RESOLVED_STATE_TOGGLED'>;
};

export const ConversationResolvedStateToggled = ({
  entry,
}: ConversationResolvedStateToggledProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);

  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = (
    <>
      Conversation is {entry.is_resolved ? 'resolved' : 'un-resolved'} by{' '}
      {authorLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
